import React from 'react';

import { trackingMessages } from '../../../../../translates/trackingMessages';
import { LoadingBar, LoadingBarType } from '../../../App/components/Loader/LoadingBar';
import { FormattedMessage } from 'react-intl';

import './MenuProjectProgress.scss';

export interface MenuProjectProgressStateProps {
  completedPercentage?: number;
}

export const MenuProjectProgress: React.FunctionComponent<MenuProjectProgressStateProps> = ({
  completedPercentage,
}) => {
  if (completedPercentage !== undefined && !Number.isNaN(completedPercentage)) {
    return (
      <div className="menu-project-progress">
        <div className="menu-project-progress__loading-bar-wrapper">
          <LoadingBar complete={completedPercentage} type={LoadingBarType.progress} />
        </div>
        <div className="menu-project-progress__progress-text">
          {completedPercentage}% <FormattedMessage {...trackingMessages.completed} />
        </div>
      </div>
    );
  }
  return null;
};
